// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useConfig } from '@hooks/other/useConfig';
import { PropsWithChildren } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Theme } from './config/config';
import { useBranding } from './contexts/BrandingContext';
import { useLocalStorage } from './contexts/LocalStorageContext';
import { dark } from './themes/dark';

export const ThemeProviderCustom: React.FC<PropsWithChildren> = ({ children }) => {
  const { theme } = useBranding();
  const darkTheme = createTheme(dark);
  const isBr = useConfig().branding?.theme === Theme.BROADRIDGE;
  const useDarkTheme = !!useLocalStorage()?.localStorageState?.isDark && !isBr;
  const selectedTheme = useDarkTheme ? darkTheme : theme;
  return <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>;
};
